import { useQueryClient } from "@tanstack/react-query";
import {
  FINANCE_PRODUCT_TYPE,
  PIPELINE,
  PENDING_CREDIT_APP,
  PURCHASE_TYPES,
  PURCHASE_INFO_CONTRACT_STATUS,
  APPROVED,
} from "../../common/Constants";

function applicationStatus(paymentDesc) {
  return paymentDesc &&
    paymentDesc.length > 0 &&
    paymentDesc[paymentDesc.length - 1]?.status
    ? paymentDesc[paymentDesc.length - 1].status
    : "--";
}

export function getPaymentType(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation) return undefined;

  const { financeProvider, paymentType } = data.customerReservation;
  if (!paymentType) return undefined;

  if (
    paymentType.toLowerCase() === FINANCE_PRODUCT_TYPE.FINANCE &&
    financeProvider === "RouteOne"
  ) {
    return "Ford Credit Financing";
  }

  if (paymentType === FINANCE_PRODUCT_TYPE.THIRD_PARTY) {
    return "Third Party Financing";
  }

  if (paymentType.toLowerCase() === FINANCE_PRODUCT_TYPE.OTHER) {
    return "Other Financing Options";
  }

  if (paymentType.toLowerCase() === FINANCE_PRODUCT_TYPE.CASH) {
    return "Cash";
  }

  if (paymentType.toLowerCase() === FINANCE_PRODUCT_TYPE.LEASE) {
    return "Lease";
  }
}

export function hasCreditApp(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation) return false;

  const { paymentType, subJourneyType } = data.customerReservation;
  if (!paymentType) return false;

  const isPipeline = subJourneyType === PIPELINE;
  const isFordCreditType = [
    FINANCE_PRODUCT_TYPE.FINANCE,
    FINANCE_PRODUCT_TYPE.FORD_OPTIONS,
    FINANCE_PRODUCT_TYPE.FLEX_BUY,
  ].includes(paymentType.toLowerCase());

  return (!isPipeline && isFordCreditType) || false;
}

export function getFordCreditAppStatus(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation?.paymentDescription) return undefined;

  const { paymentDescription } = data.customerReservation;
  const status = applicationStatus(paymentDescription);
  return status === PENDING_CREDIT_APP ? "Pending" : status;
}

export function get3pfCreditAppStatus(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation?.paymentDescription?.[0]?.status)
    return undefined;

  return data.customerReservation.paymentDescription[0].status.toUpperCase();
}

export function getAutoFiLoanAppId(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation) return null;

  const { financeLoanAppId, paymentDescription } = data.customerReservation;
  if (!paymentDescription?.[0]?.status) return null;

  return paymentDescription[0].status.toUpperCase() === APPROVED
    ? financeLoanAppId
    : null;
}

export function getEsignStatus(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation?.purchaseType) return "No";

  return data.customerReservation.purchaseType === PURCHASE_TYPES.SIGN_ONLINE
    ? "Yes"
    : "No";
}

export function displayAlternativeLending(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation) return "--";

  const { paymentType, alternativeLenderSelection } = data.customerReservation;
  return (
    (paymentType === FINANCE_PRODUCT_TYPE.FINANCE &&
      alternativeLenderSelection) ||
    "--"
  );
}

export function getContractStatus(orderId) {
  const queryClient = useQueryClient();
  const data = queryClient.getQueryData(["order", { orderId }]);
  if (!data?.customerReservation?.purchaseInfo?.contractStatus) return "--";

  return data.customerReservation.purchaseInfo.contractStatus ===
    PURCHASE_INFO_CONTRACT_STATUS.SIGNED
    ? "Contract Signed"
    : "--";
}
